import dataBloedErnstigFactorXa from "../../../../src/data/ernstige-bloedingen-onder-doac-factor-xa.json";
import BasicSchematic from "../../../../src/components/chart/interaction/basic-schematic/Chart.js";
import * as React from 'react';
export default {
  dataBloedErnstigFactorXa,
  BasicSchematic,
  React
};